module.exports = __webpack_public_path__ + "media/images/disbursement_channels/viettel-ef77b5ce1508221b64ea9202334fcf82.svg";